import { Expose, Transform, Type } from "class-transformer";
import { PermissionEnum } from "@altertec_gparn/lib";
import { toCents } from "@/utils/numberUtils";

export class UpdatePurchaseApprovalLineDto {
  @Expose()
  permission: PermissionEnum;

  @Expose()
  @Type(() => Number)
  @Transform(({ value }) => toCents(value))
  minAmount: number;
}
